import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireBackofficeSession } from '@/lib/require-backoffice-session'

export const Route = createFileRoute('/queue')({
	ssr: false,
	beforeLoad: requireBackofficeSession,
	component: QueueLayout
})

function QueueLayout() {
	return <Outlet />
}
